'use client';

import { text, vstack } from '@onbeam/business-styled-system/patterns';
import { Link, SuperstateButton } from '@onbeam/business-ui';
import { DrawerField } from '@/components/shared/DrawerField';
import { FormReviewGroup } from '@/components/features/Form/FormReviewGroup';
import { format } from 'date-fns';
import { MarkdownRenderer } from '@/components/shared/MarkdownRenderer';
import { css } from '@onbeam/business-styled-system/css';
import { useEffect, useState } from 'react';
import { BountyFormSchema } from '../BountyForm.utils';
import { useFormContext } from '@/components/features/Form/FormContext';
import { applicationTeamTypeMap } from '@/components/features/Applications/ApplicationsList/ApplicationsList.types';

export const BountyFormReview = () => {
  const {
    form: {
      getValues,
      formState: { isSubmitting },
    },
  } = useFormContext<BountyFormSchema>();
  const [data, setData] = useState<BountyFormSchema>();

  useEffect(() => {
    setData(getValues());
  }, [getValues]);

  if (!data) return null;

  return (
    <div className={vstack({ gap: '10' })}>
      <h1 className={text({ style: 'subtitle-md' })}>Review & submit</h1>
      <FormReviewGroup title="Bounty Details" stepIndex={0}>
        <DrawerField
          title="Idea"
          description={<MarkdownRenderer>{data.idea}</MarkdownRenderer>}
        />
      </FormReviewGroup>
      <hr className={css({ w: 'full', color: 'opacity.md' })} />
      <FormReviewGroup title="Introduce your team" stepIndex={1}>
        <DrawerField
          title="Team type"
          description={applicationTeamTypeMap[data.teamType]}
        />
        <DrawerField
          title="Team"
          description={
            <MarkdownRenderer>{data.teamDescription}</MarkdownRenderer>
          }
        />
      </FormReviewGroup>
      {(data.estimatedCost || data.dateRange || data.demoURL) && (
        <>
          <hr className={css({ w: 'full', color: 'opacity.md' })} />
          <FormReviewGroup title="Extra details" stepIndex={2}>
            {data.estimatedCost && (
              <DrawerField
                title="Estimated cost"
                description={
                  <MarkdownRenderer>{data.estimatedCost}</MarkdownRenderer>
                }
              />
            )}
            {data.dateRange && (
              <DrawerField
                title="Delivery time"
                description={
                  <ul>
                    <li>Start: {format(data.dateRange.from, 'MMMM yyyy')}</li>
                    <li>
                      Expected completion:{' '}
                      {format(data.dateRange.to, 'MMMM yyyy')}
                    </li>
                  </ul>
                }
              />
            )}
            {data.demoURL && (
              <DrawerField
                title="MVP Link"
                description={
                  <Link
                    href={data.demoURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="blue"
                  >
                    {data.demoURL}
                  </Link>
                }
              />
            )}
          </FormReviewGroup>
        </>
      )}
      <SuperstateButton
        type="submit"
        buttonClassName={css({ w: 'full' })}
        isLoading={isSubmitting}
      >
        {!isSubmitting && 'Submit'}
      </SuperstateButton>
    </div>
  );
};
